import { render, staticRenderFns } from "./ghost-slot.vue?vue&type=template&id=4eef3752"
import script from "./ghost-slot.vue?vue&type=script&lang=js"
export * from "./ghost-slot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports